import { LocaleList } from '@gelato-api-ui/core/i18n/locales.constant';

export const isSupportedLocale = (locale: string): boolean =>
  Boolean(LocaleList.find(_locale => _locale.code === locale));
